/**
 * Exact badge tints of the "Droits utilisateurs v4" mockup (documentation/notepad),
 * measured on its `.chip` and `.chip--ea` elements. They are the mockup's own slate / sky
 * tints, with no equivalent theme token, so they are kept here for the two users columns.
 */
export const USER_BADGE_COLORS = {
  /** Mockup `.chip`: rights profile and country / terrain perimeter. */
  default: { color: '#64748B', bgcolor: '#EEF1F5' },
  /** Mockup `.chip--ea`: "all countries" perimeter. */
  allCountries: { color: '#0369A1', bgcolor: '#E5F3FB' },
} as const;
